import React, { ReactNode, useState } from 'react';
import { FlexRow, BoldHeader5Text, NavigationItem, SmallBodyText, Tooltip } from 'ui-toolkit';
import { DarkFaEdit } from '../../../order/overview/Summary/DarkFaEdit';
import { OutsideClickWrapper } from '../../../order/overview/Summary/OutsideClickWrapper';
import { ISummaryItemProps } from './SummaryItem';
import { StyledSummaryItem } from './SummaryItem.styles';
import { useShouldSummaryItemRender } from '../useShouldSummaryItemRender';

export interface ISummaryItemWithTooltipProps<T extends { onClose: () => void }> extends ISummaryItemProps {
  tooltip: React.FC<T>;
  tooltipProps: Omit<T, 'onClose'>;
  'data-test-id'?: string;
  children: ReactNode;
}

export const SummaryItemWithTooltip = <T extends { onClose: () => void }>(props: ISummaryItemWithTooltipProps<T>) => {
  const { children, label, tooltip: OurToolTip, tooltipProps, tab } = props;
  const [show, setShow] = useState<boolean>(false);
  const shouldRender = useShouldSummaryItemRender(label, tab);
  if (!shouldRender) {
    return null;
  }
  return (
    <StyledSummaryItem>
      <FlexRow justifyContent={'space-between'}>
        <BoldHeader5Text>{label}</BoldHeader5Text>
        <Tooltip
          tooltipShown={show}
          placement={'bottom'}
          tooltipContent={
            <OutsideClickWrapper onOutsideClick={() => setShow(false)}>
              <OurToolTip {...(tooltipProps as any)} onClose={() => setShow(false)} />
            </OutsideClickWrapper>
          }
        >
          <NavigationItem text={`Edit ${label}`} onClick={() => setShow(true)}>
            <DarkFaEdit data-test-id={`${props['data-test-id']}-edit-button`} />
          </NavigationItem>
        </Tooltip>
      </FlexRow>
      <SmallBodyText>{children}</SmallBodyText>
    </StyledSummaryItem>
  );
};
